import { render, staticRenderFns } from "./ListaRetornos.vue?vue&type=template&id=bc5912be&"
import script from "./ListaRetornos.vue?vue&type=script&lang=js&"
export * from "./ListaRetornos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports